import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { TransactionsStore } from './transactions.store';

const TransactionsContext = React.createContext<TransactionsStore | null>(null);

export const TransactionsProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<TransactionsStore>(() => new TransactionsStore(navigate));

   return <TransactionsContext.Provider value={store}>{children}</TransactionsContext.Provider>;
};

export const useTransactions = () => {
   const ctx = React.useContext(TransactionsContext);
   if (!ctx) {
      throw new Error('useTransactions must be used inside TransactionsProvider');
   }

   return ctx;
};
